export const pageViewPixel = async (value) => {
    await window.fbq('track', 'ViewContent', {
        content_name: value,
        content_type: 'pamphlet',
        content_ids: value._id
    })
}

export const PamphletPageView = async () => {
    await window.fbq('track', 'Lead')
}

export const CategoryPageView = async (value) => {
    await window.fbq('track', 'ViewContent', {
        content_name: value.name,
        content_type: 'category',
        content_ids: value._id
    })
}

export const ProductDetailView = async (value) => {
    await window.fbq('track', 'ViewContent', {
        content_name: value.title,
        content_type: 'product',
        content_category: value.category.name,
        content_ids: value._id,
        value: value.price,
        currency: 'INR',
    })
}

export const ProductSearchedPixel = async (value) => {
    await window.fbq('track', 'Search', {
        search_string: value
    })
}

export const PixelAddToCart = async (value) => {
    await window.fbq('track', 'AddToCart', {
        content_name: value.title,
        content_type: 'product',
        content_category: value.category.name,
        content_ids: value._id,
        value: value.price,
        currency: 'INR',
    })
}

export const PixelInitiatCheckout = async (value, total) => {
    await window.fbq('track', 'InitiateCheckout', {
        value: total,
        currency: 'INR',
        content_name: 'Checkout',
        content_category: 'snippets',
        content_type: 'ADD_TO_CART',
        contents: [
            value.map((p) => (
                {
                    id: p._id,
                    quantity: p.count
                }
            ))
        ],
        num_ids: value.length
    })
}

export const PixelCheckoutDone = async (value, total) => {
    await window.fbq('track', 'Purchase', {
        value: total,
        currency: 'INR',
        content_name: 'Checkout',
        content_category: 'snippets',
        content_type: 'product',
        contents: [
            value.map((p) => (
                {
                    id: p._id,
                    quantity: p.count
                }
            ))
        ],
        num_ids: value.length
    })
}

export const GoogleCheckoutDone = async (value, total, shipping, packing, specialId) => {
    await window.dataLayer.push({
        event: 'Purchase',
        'ecommerce': {
            'purchase': {
                'actionField': {
                    'id': specialId,
                    'affiliation': 'Online Store',
                    'revenue': total,
                    'method': 'Cash On Delivery',
                    'shipping': shipping,
                    'packing': packing
                },
                'products': [
                    value.map((p) => (
                        {
                            id: p._id,
                            quantity: p.count,
                            'name': p.product.title,     
                            'id': p.product._id,
                            'price': p.price,
                            'quantity': p.count,
                        }
                    ))
                   ]
            }
        }
    })
}